import actions from '@/core/store/item-ata/alterar-classificacao/alterar/actions'
import getters from '@/core/store/item-ata/alterar-classificacao/alterar/getters'
import state from '@/core/store/item-ata/alterar-classificacao/alterar/state'
import mutations from '@/core/store/item-ata/alterar-classificacao/alterar/mutations'

export default { actions, getters, state, mutations }
